<h1 class="title">
  <p-button
    class="prev"
    icon="pi pi-chevron-left"
    label="Précédent"
    [rounded]="true"
    [text]="true"
    severity="secondary"
    (onClick)="prev.emit()"
    styleClass=""
    aria-label="Retour">
  </p-button>
  QUESTION {{question().id}}
</h1>

<div class="image relative">
  <img [src]="`assets/questions/question_${question().id}.jpg`">
</div>
<h2 class="question">{{ question().label }}</h2>

<div class="flex flex-column gap-3">
  @for (opt of shuffledOptions(); track opt.label) {
    <p-button [label]="opt.label"
              class="buttons clickable"
              severity="secondary"
              styleClass="round-buttons clickable"
              (onClick)="onSelection(opt)">
    </p-button>
  }
</div>
